import { render } from "./dashboard.layouts.vue?vue&type=template&id=338ca388"
import script from "./dashboard.layouts.vue?vue&type=script&lang=js"
export * from "./dashboard.layouts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__